// Homepage demo video identity. Kept in a plain module (no "use client")
// because both the server-rendered section in LandingPageContent and the
// client-side player import it. A non-component export from a "use client"
// file is not a value on the server but a client reference proxy, which is
// what turned the "watch on YouTube" href into a serialized function once.

// Replaced 2026-09-20 with the 5:16 explainer cut from live screens of the
// current build. The previous id (1pH2J6M-Yq0, the launch film) is still the
// video behind /watch/slitting-line-setup-software — that page carries its own
// VideoObject schema in src/lib/seo/videos.ts and was left as it was.
export const DEMO_VIDEO_ID = "ywK4Ot2mvYY";
export const DEMO_VIDEO_TITLE = "Slitting Line Setup: Knives, Spacers and Both Arbors";
export const DEMO_VIDEO_WATCH_URL = `https://www.youtube.com/watch?v=${DEMO_VIDEO_ID}`;
